var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      class: _vm.popupData.customClass,
      attrs: { id: "classificationConfirmationPopup", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header generic-header" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
            _c("img", {
              staticClass: "close-icon cursor-pointer",
              attrs: {
                src: "/static/images/icons/close_icon.svg",
                "data-dismiss": "modal",
                "data-target": "#classificationConfirmationPopup",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "closeConfirmationPopup",
                    _vm.popupData.cancelButtonValue
                  )
                },
              },
            }),
          ]),
          _c("div", { staticClass: "modal-body pt-0" }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.popupData.body) } }),
          ]),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm.popupData.buttonsType === "confirmation"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-white-button wd-220",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "data-target": "#classificationConfirmationPopup",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit(
                              "closeConfirmationPopup",
                              _vm.popupData.cancelButtonValue
                            )
                          },
                        },
                      },
                      [_vm._v(" No, Cancel ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button wd-220",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "data-target": "#classificationConfirmationPopup",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit(
                              "closeConfirmationPopup",
                              _vm.popupData.confirmButtonValue
                            )
                          },
                        },
                      },
                      [_vm._v(" Yes, Confirm ")]
                    ),
                  ]
                : _vm.popupData.buttonsType === "normal"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button wd-220",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "data-target": "#classificationConfirmationPopup",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit(
                              "closeConfirmationPopup",
                              _vm.popupData.confirmButtonValue
                            )
                          },
                        },
                      },
                      [_vm._v(" OK ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }